import { Component } from "react";
import Loader from "../../../../../utils/Loader";
import { ToastContainer } from "react-toastify";
import { withRouter } from "../../../../../utils/withRouter";
import { connect } from "react-redux";
import { fill_action } from '../../../../../actions/fillCombo_action';
import { cityActionId, countryActionId, toastError, toastSuccess } from "../../../../../utils/constants";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Modal from "react-modal";
import moment from "moment";
import AdminDrawer from "../../../../../common_components/admin_module_drawer";
import HeaderWithLogo from "../../../../../common_components/header_with_logo";
import { useNavigate } from "react-router-dom";
import ExhibitorDrawer from "../../../../../common_components/exhibitor_module_drawer";
import ExhibitorHeader from "../../../../../common_components/exhibitor_module_header";
import { data } from "jquery";
import { getRightsMasterList_action, updateRightsMaster_action } from "../../../../../actions/admin_module_action/master_action/exhibition_master_action/exh_spacebookingFreeze_action";


class SpacebookingFreezeMaster extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            // Name: '',
            // is_add: false,
            ExhibitionID: '',
            // is_update: false,
            inputList: [],
            // reportList: [],
            // isDisplayCountryList: false,
            // selectedModeuleList: [],
        }
        this.getFillList = this.getFillList.bind(this)
        // this.onCountrySearch = this.onCountrySearch.bind(this)
        // this.renderCountryList = this.renderCountryList.bind(this)
        // this.addRoleMaster = this.addRoleMaster.bind(this)
        this.getRightsMasterDetails = this.getRightsMasterDetails.bind(this)
        // this.handleBack = this.handleBack.bind(this)
        this.updateRightsMaster = this.updateRightsMaster.bind(this)
        // this.RoleMasterAU = this.RoleMasterAU.bind(this)
        this.rightsRecord = this.rightsRecord.bind(this)
        // this.getRightsMasterDetailsDefault = this.getRightsMasterDetailsDefault.bind(this)
        this.onRightsSelect = this.onRightsSelect.bind(this)
        // this.reportRecord = this.reportRecord.bind(this)
    }

    componentDidMount() {
        this.setState({
            ExhibitionID: this.props.location.state.ExihibitionID != undefined ? (this.props.location.state != null && this.props.location.state.ExihibitionID != null ? this.props.location.state.ExihibitionID : '') : this.props.id != null && this.props.id != undefined ? this.props.id : '',
        })

        setTimeout(() => {
            this.getRightsMasterDetails()
            console.log(this.state.inputList)
        }, 200);
    }


    getFillList(actionID, exhibitionID, moduleID, keyValue, value, from) {
        const { } = this.state
        this.setState({ isLoading: true })
        this.props.fill_action(actionID, exhibitionID, moduleID, keyValue, value)
            .then((data) => {
                if (data.error != 1) {
                    // Country List
                    if (actionID === countryActionId) {
                        console.log("country data", data.data)
                        this.setState({
                            countryList: data.data,
                            TempCountryList: data.data,
                            isLoading: false
                        })
                    }
                }
                this.setState({ isLoading: false })
            }
            )
    }

    getRightsMasterDetails() {
        const { ExhibitionID } = this.state
        this.setState({ isLoading: true })
        this.props.getRightsMasterList_action(ExhibitionID)
            .then((data) => {
                if (data.error != 1) {
                    console.log(data.data)
                    // data.data.inputList.length > 0 && data.data.inputList.sort((a, b) =>
                    //     a.ModuleName.toLowerCase().localeCompare(b.ModuleName.toLowerCase())
                    // );
                    // data.data.reportList.length > 0 && data.data.reportList.sort((a, b) =>
                    //     a.ReportName.toLowerCase().localeCompare(b.ReportName.toLowerCase())
                    // );
                    this.setState({
                        // Name: data.data.RoleName,
                        // RoleID: data.data.RoleID,
                        inputList: data.data,
                        // reportList: data.data.reportList,
                    })
                    // this.state.countryList.map(id => parseInt(id.CountryCode) == data.data[0].CountryID && this.setState({ Country: id.Description }))
                    this.setState({ isLoading: false })
                }
                else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((err) => {
                console.log(err)
            })
    }


    updateRightsMaster() {
        const { Name, RoleID, inputList, ExhibitionID, reportList } = this.state

        this.setState({ isLoading: true })
        this.props.updateRightsMaster_action(ExhibitionID, inputList)
            .then((data) => {
                if (data.error != 1) {
                    this.setState({ isLoading: false })
                    toastSuccess("data updated successfully")
                }
                else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((err) => {
                console.log(err)
            })
    }

    onRightsSelect(i) {
        const { selectedModeuleList, inputList } = this.state
        // console.log(inputList)
        if (inputList[i].IsActive == 1) {
            inputList[i].IsActive = 0
        }
        else {
            inputList[i].IsActive = 1
        }
        this.setState({ inputList: inputList })
        console.log(inputList,)
    }

    rightsRecord(list) {
        return (
            <table className="table border text-nowrap text-md-nowrap table-bordered mb-0">
                <thead>
                    <tr>
                        <th>Rights Name</th>
                        <th style={{ width: '80px' }} className="text-center">Editable</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        list.length > 0 ? <>{
                            list.map((data, i) => (
                                <tr key={i}>
                                    <td>{data.RightsName}</td>
                                    <td style={{ textAlign: 'center' }}>
                                        <input onClick={(e) => this.onRightsSelect(i)} checked={data.IsActive} type="checkbox" />
                                    </td>
                                </tr>
                            ))}
                        </> :
                            <tr><td colSpan={13} style={{ textAlign: 'center' }}>Record not found</td></tr>
                    }
                </tbody>
            </table>)
    }

    render() {
        const { isLoading, Name, inputList, reportList } = this.state
        return (
            <>
                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    null
                )}
                <ToastContainer />
                <HeaderWithLogo />
                <AdminDrawer />
                <div className="main-container">
                    <div className="row exb-top-space mx-2">
                        <div className="row mt-5">
                            {/* <div class="col-md-4">
                                        <label for="validationCustom03">Code<span style={{ color: 'red' }}>*</span></label>
                                        <input value={Code} onChange={(e) => this.setState({ Code: e.target.value })} type="text" class="form-control" placeholder="Code" />
                                    </div>
                                    <div className="col-xl-4">
                                        <label htmlFor="validationCustom03">
                                            Country<span className="text-red">*</span>
                                        </label>
                                        <input
                                            placeholder="Country"
                                            type="text"
                                            className="form-control"
                                            id="validationCustom03"
                                            value={Country}
                                            onChange={(e) => this.onCountrySearch(e)}
                                        />
                                        {isDisplayCountryList && this.renderCountryList()}

                                    </div> */}
                            <h5 className="m-4 ms-0" style={{ textAlign: 'left' }}>RIGHTS LIST</h5>
                            {this.rightsRecord(inputList)}
                            <div class="col-md-12">
                                <button type="button" class="btn btn-aqua rounded-1 mt-4" style={{ float: 'right' }}
                                    onClick={(e) => this.updateRightsMaster()}>
                                    Save
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

            </>
        )
    }
}

export default withRouter(connect(null, { fill_action, getRightsMasterList_action, updateRightsMaster_action })(SpacebookingFreezeMaster));